import { createElement, lazy } from 'react'

import { routes } from '../routes'
import RoleRestricted from '../utils/roleRestricted'
import { registerRoute } from '../utils/routeRegistry'

const UserSettings = lazy(() => import(/* webpackChunkName: 'settings' */ './containers/userSettings'))
const AdminSettings = lazy(() => import(/* webpackChunkName: 'settings' */ './containers/adminSettings'))

const initRoute = () => {
    registerRoute({ path: routes.SETTINGS_USER + '/:section?', element: createElement(UserSettings) })
    registerRoute({
        path: routes.SETTINGS_ADMIN,
        element: createElement(
            RoleRestricted,
            { allowedRoles: ['APPLICATION_ADMIN', 'MANAGER_PRINCIPAL_USED_CARS'] },
            createElement(AdminSettings),
        ),
    })
}

export default initRoute
